module.exports = __webpack_public_path__ + "img/pic_simu@2x (1).8dae69d4.png";